/** Normalized path for teacher sidebar label lookup (no query, lowercase). */
export function normalizeSidebarPathKey(path: string | null | undefined): string {
  if (!path || typeof path !== 'string') return ''
  let p = path.trim().toLowerCase().split('?')[0]
  if (p.endsWith('/') && p.length > 1) p = p.slice(0, -1)
  return p
}

const TEACHER_MENU_LABELS_BY_PATH: Record<string, string> = {
  '/posting-history': 'My school postings',
  '/teacher-profile': 'Personal details',
  '/track-status': 'Transfer application status',
  '/grievances': 'My grievances'
}

/** Sidebar text for a menu row; teachers get clearer labels for key routes. */
export function resolveSidebarMenuLabel(
  item: { label?: string; path?: string | null },
  role: string | undefined | null
): string {
  if (item.label === 'PTR Analytics Dashboard' || normalizeSidebarPathKey(item.path) === '/school-strength-report') {
    return 'PTR Analytics'
  }
  if (role?.toLowerCase() !== 'teacher') {
    return item.label ?? ''
  }
  const key = normalizeSidebarPathKey(item.path)
  return TEACHER_MENU_LABELS_BY_PATH[key] ?? item.label ?? ''
}
